export const api = "http://localhost:7000/api/"

export const scoreType = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 'percentage', label: 'Percentage' },
    { value: 'grade', label: 'Grade' },
    { value: 'CGPA', label: 'CGPA' },
  ]
  
export const divisionTypes = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 1, label: 'First' },
    { value: 2, label: 'Second' },
    { value: 3, label: 'Third' },
    { value: 0, label: 'Not Applicable' },
  ]

export const empType = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 'fulltime', label: 'Full-time' },
    { value: 'parttime', label: 'Part-time' },
    { value: 'self', label: 'Self Employed' },
    { value: 'freelance', label: 'Freelance' },
    { value: 'contract', label: 'Contract' },
    { value: 'internship', label: 'Internship' },
    { value: 'apprenticeship', label: 'Apprenticeship' },
  ]
export const remunerationBands = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 0, label: 'Does not apply' },
    { value: 1, label: 'below 5 LPA'},
    { value: 2, label: '5 to 10 LPA' },
    { value: 3, label: '10 to 15 LPA' },
    { value: 4, label: '15 to 20 LPA' },
    { value: 5, label: '20+ LPA' },
  ]

export const currencyList = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 0, label: 'INR' },
    { value: 1, label: 'USD'},
    { value: 2, label: 'POUND'},
  ]

export const accomplishmentTypes = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 'awards', label: 'Awards' },
    { value: 'projects', label: 'Projects' },
    { value: 'courses', label: 'Courses' },
    { value: 'events', label: 'Events' },
    { value: 'volunteer', label: 'Volunteer Services' },
    { value: 'publications', label: 'Publications' },
    { value: 'conferences', label: 'conferences' },
    { value: 'patents', label: 'patents' },
  ]

  export const relocateType = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 'outCountry', label: 'Within Country' },
    { value: 'inCountry', label: 'Out of Country'},
  ]

  export const visaType = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 'b1b2', label: 'B1/B2 US Visa' },
    { value: 'l1', label: 'L1 US Visa'},
  ]

export const keyValueMap = {
    mean: 'Mean',
    median: 'Median',
    mode: 'Mode',
    gmean: 'Geometric Mean',
    hmean: 'Harmonic Mean',
    q1: 'Q1 (25th)',              
    q3: 'Q3 (75th)',
    IQR: 'IQR',
    IQRrule: '1.5 IQR Rule',
    min: 'Minimum',              
    max: 'Maximum',
    range: 'Range',
    std: 'Standard Deviation',
    var: 'Variance',              
    sem: 'Standard Error',
    aad: 'Average Absolute Deviation (AAD)',
    mad: 'Median Absolute Deviation (MAD)',
    sqDev: 'Squared Deviation',
    coVar: 'Coefficient of Variation',
    skew: 'Skewness',
    kurtosis: 'Kurtosis',
    exkurtosis: 'Ex-Kurtosis',
    sum: 'Sum',
    count: 'Count',
    missing: 'Missing',
    dtype: 'Data Type',              
    unique: '# of Groups (Categorical Only)',
    shannon: 'Shannon’s Index',
    brillouin: 'Brillouin’s Index',
    simpson: 'Simpson’s Index',
    fisher: "Fisher Information Matrix",
    covarianceMatrix: "Covariance Matrix",

    shapiro: 'Shapiro-Wilk Test',
    chisquare: 'Chi-square Test',
    kstest: 'Kolmogorov-Smirnov Test',
    lilliefors: 'Lilliefors Test',
    chenshapiro: 'Chen-Shapiro Test',
    vonmises: 'Cramér–von Mises Test',
    watson: 'Watson Test',
    anderson: 'Anderson-Darling Test',
    kuipers: 'Kuipers Test',
    shapirofrancia: 'Shapiro-Francia Test',
    wsTest: 'W/S Test',
    grubbs: 'Grubbs Test',
                  
    esd: 'Generalized Extreme Studentized Deviate (ESD)',
    dixons: 'Dixons Q Test',
    cochrans: 'Cochrans C Test',  
    mandelhk: 'Mandels h and k Statistics',
    tlamsG: 't Lams G Test',  
    jarqueBera: 'Jarque-Bera Test',              
    normal: 'D’Agostino-Pearson',
}

export const diagnosticKeys = {
    "Central Tendency" : ['mean','median','mode','gmean','hmean'],
    "Percentile": ['q1','q3','IQR','IQRrule'],
    "Dispersion": ['max','min','std','var','sem','aad','mad','sqDev','coVar'],
    "Distribution": ['skew','kurtosis','exkurtosis'],
    "General": ['sum','count','missing','dtype','unique'],
    "Diversity Indices": ['shannon','brillouin','simpson'],
    'Statistical Tests': ['shapiro', 'chisquare','kstest','lilliefors','chenshapiro','vonmises','watson','anderson','kuipers','shapirofrancia','wsTest'],
    'Skewness & Kurtosis': ["jarqueBera", "normal"],
    'Identifying Outliers': ['grubbs','esd','dixons','cochrans','mandelhk','tlamsG']
}

export const pagesDesp = {
    source : {
        title: "Source",
        subTitle: "Data",
        desp: "Ingest and Transform",        
        path: '/source'
    },
    
    build : {
        title: "Build",
        subTitle: "Models",
        desp: "Create Statistical Models",
        path: '/build',
        childlink: ['blandaltman', 'anova'],
        subchildlink: ['data', 'diag', 'transform', 'model', 'design', 'log', 'lib']
    },
    
    plan : {
        title: "Plan",
        subTitle: "Scenarios",
        desp: "Simulate and Optimize",
        path: '/plan'
    },
    
    review : {
        title: "Review",
        subTitle: "Metrics",
        desp: "View Business Metrics",
        path: '/review'
    }
}
